import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "jam_token";
const ACTING_KEY = "jam_acting_org";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const getActingOrg = () => localStorage.getItem(ACTING_KEY);
export const setActingOrg = (id) => { if (id) localStorage.setItem(ACTING_KEY, id); else localStorage.removeItem(ACTING_KEY); };
export const clearActingOrg = () => localStorage.removeItem(ACTING_KEY);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const acting = getActingOrg();
  if (acting) config.headers["X-Acting-Org"] = acting;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
